import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { PURCHASE_PREPAID_SUBSCRIPTION_REQUEST, PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS, PURCHASE_PREPAID_SUBSCRIPTION_ERROR } from '../types';
var purchasePrepaidSubscriptionRequest = function purchasePrepaidSubscriptionRequest(payload) {
  return {
    type: PURCHASE_PREPAID_SUBSCRIPTION_REQUEST,
    payload: payload
  };
};
var purchasePrepaidSubscriptionError = function purchasePrepaidSubscriptionError(error, payload) {
  return {
    type: PURCHASE_PREPAID_SUBSCRIPTION_ERROR,
    payload: payload,
    error: error
  };
};
var purchasePrepaidSubscriptionSuccess = function purchasePrepaidSubscriptionSuccess(payload, cart, lineItem, prepaidSubscription) {
  return {
    type: PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS,
    payload: payload,
    cart: cart,
    lineItem: lineItem,
    prepaidSubscription: prepaidSubscription
  };
};
export var purchasePrepaidSubscription = function purchasePrepaidSubscription(payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var chord, _getState, auth, cart, orderIdentifier, lineItem, prepaidSubscription;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref.chord;
            dispatch(purchasePrepaidSubscriptionRequest(payload));
            _getState = getState(), auth = _getState.auth;
            _context.prev = 3;
            _context.next = 6;
            return chord.oms.createOrder(auth.token);
          case 6:
            cart = _context.sent;
            orderIdentifier = {
              number: cart.number,
              token: cart.token
            };
            _context.next = 10;
            return chord.oms.addLineItem(orderIdentifier, auth.token, payload);
          case 10:
            _context.next = 12;
            return chord.oms.prepareCheckout(orderIdentifier, auth.token);
          case 12:
            cart = _context.sent;
            lineItem = cart.lineItems.find(function (li) {
              return li.variant.sku === payload.lineItem.sku;
            });
            prepaidSubscription = lineItem.prePaidSubscription;
            dispatch(purchasePrepaidSubscriptionSuccess(payload, cart, lineItem, prepaidSubscription));
            return _context.abrupt("return", cart);
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](3);
            dispatch(purchasePrepaidSubscriptionError(_context.t0, payload));
            throw _context.t0;
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 19]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};